import { Component, Inject, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { MatAutocomplete } from "@angular/material/autocomplete";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Observable, Subject } from "rxjs";
import { takeUntil, switchMap, filter } from "rxjs/operators";
import { Papa } from "ngx-papaparse";
import { ConfirmDialogComponent } from "../dialogs/confirm-dialog/confirm-dialog.component";
import { SnackbarComponent } from "../snackbar/snackbar.component";
import { HeaderService } from "../header/header.service";
import { ShipyardService } from "src/app/modules/shipyard/shipyard.service";
import { PlanyardService } from "src/app/modules/planyard/planyard.service";
import { InventoryService } from "src/app/services/inventory.service";
import { ShipmentSku } from "src/app/models/shipyard.model";

@Component({
  selector: "app-assign-tags",
  templateUrl: "./assign-tags.component.html",
  styleUrls: ["./assign-tags.component.scss"],
})
export class AssignTagsComponent implements OnInit,OnDestroy{
  spin: boolean=false;
  form: FormGroup = new FormGroup({
    skuAutocomplete: new FormControl(),
  });
  importBulkForm: FormGroup = new FormGroup({
    skuList: new FormControl(null, [Validators.required]),
  });
  validatorSpin = false;
  importBulk: boolean=false;
  invalidSkus: string[] = [];
  validatedSku :boolean= false;
  private destroy$ = new Subject<void>();
  filteredOptions$: Observable<any>;
  shipmentSkuList: ShipmentSku[] = [];
  selectTags: any[] = [];
  isShowTags: boolean = false;
  account: string;
  allTags: any[] = [];
  selectedSKU: any[] = [];
  selectedItems: any[] = [];
  startRow:number=0;
  amountPerPage:number=10;
  @ViewChild("auto") public scroll!: MatAutocomplete;
  hasData: boolean = false;
  selectedRows:any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<AssignTagsComponent>,
    private shipyardService: ShipyardService,
    private headerService: HeaderService,
    private inventoryService: InventoryService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private planyardService: PlanyardService,
    private papa: Papa
  ) {
    this.headerService.accountsSelected.pipe(takeUntil(this.destroy$)).subscribe((e) => (this.account = e[0]));
  }

  ngOnInit(): void {
    this.getTags();
    if(this.data.page === "shipyard" || this.data.page=='replenish' )
      {
        if(this.data?.selectedRows){
          this.selectedRows=this.data?.selectedRows;
          this.selectedRows.forEach((ele)=>{
            if(ele){
              ele.account=ele.Account;
              ele.accountSkuId=ele.AccountSkuId;
              ele.accountType=ele.AccountType;
              ele.asin=ele.Asin;
              ele.caseQty=ele.CaseQty;
              ele.fbaType=ele.FbaType;
              ele.fnsku=ele.FnSku;
              ele.imageUrl=ele.Image;
              ele.prep=ele.Prep;
              ele.qty=ele.Qty;
              ele.sku=ele.Sku;
              ele.title=ele.Title;
            }
          })
         this.selectedSKU=this.selectedRows;
        }
        this.filteredOptions$ = this.form.get("skuAutocomplete").valueChanges.pipe(
            switchMap((value) =>
              this.shipyardService.TypeaheadSku(
                this.account,
                value,
                "",
                null,
                true
              )
            )
          ) 
      }
    else {
      this.filteredOptions$ = this.form.get("skuAutocomplete").valueChanges.pipe(
          switchMap((value) => typeof value !== 'object' || Array.isArray(value) ? this.planyardService.TypeaheadItem(
            value,
            null,
            "Item",
            this.startRow,
            this.startRow + this.amountPerPage
          ) : '' )
        );
      }
        this.filteredOptions$.subscribe((res)=>{
          this.hasData = res.length > 0;
        })
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  getTags() {
    this.inventoryService.GetTags().pipe(takeUntil(this.destroy$)).subscribe(
      {
        next:(res:any)=>{
          if (res) {
            this.allTags = res;
          }
        }, error:(error)=>{
          this.snackBar.openFromComponent(SnackbarComponent, {
            duration: 3000,
            horizontalPosition: "center",
            data: {
              title: error?.error?.error[0],
              action: "Dismiss",
              type: "error",
            },
          });
        }
      }
    );
  }

  action(event) {
    if(event=='Save' || event == 'Remove'){
      this.save()
    } else if (this.importBulk) {
      this.importBulk = false;
      this.invalidSkus = [];
      this.validatedSku = false;
    } else {
      this.close();
    }
  }

  close() {
    this.dialogRef.close();
  }

  save() {
    this.spin = true;
    this.assignBulkTag();
  }

  assignBulkTag() {
    const tagIds = this.selectTags.map(ele => ele.tagId);
    const itemId = this.selectedItems.map(ele => ele.id);
    const accountSkuIds = this.selectedSKU.map(ele => ele.accountSkuId);
    let payload:any={};
    let endpoint:any
    if(this.data.title == 'Assign Tags'){
      endpoint = this.inventoryService.BulkAddTagsInProduct(payload);
      if(this.data.page === "shipyard" || this.data.page=='replenish'){
        endpoint=this.inventoryService.BulkAddTagsInSku(payload);
        payload.accountSkuId = accountSkuIds;          
        payload.tagIds =  tagIds;     
      } else {
        payload.itemId = itemId;
        payload.tagId = tagIds;
      }
    }else{
       endpoint= this.inventoryService.removeProductTags(payload);;
      if(this.data.page === "shipyard" || this.data.page=='replenish'){
        endpoint= this.inventoryService.removeSkuTags(payload);
        payload.accountSkuIds = accountSkuIds;          
        payload.tags =  tagIds;     
      } else {
        payload.item = itemId;
        payload.tags = tagIds;
      }
    }
    endpoint.pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 3000,
          horizontalPosition: "center",
          data: {
            title: this.data.title == 'Assign Tags' ?  "Tags assigned successfully" : 'Sku Tags has been removed successfully',
            action: "Dismiss",
            type: "success",
          },
        });
        this.dialogRef.close('Save');
      },
      error: (error) => {
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 3000,
          horizontalPosition: "center",
          data: {
            title: error?.error?.error[0],
            action: "Dismiss",
            type: "error",
          },
        });
      },
      complete:()=>{
        this.spin = false;
      }
    });
  }

  selectTag(tag): void {
    const selectedTagIndex = this.allTags.findIndex((ele) => ele.tagId === tag.tagId);
    if (selectedTagIndex !== -1) {
      this.allTags.splice(selectedTagIndex, 1);
      this.selectTags.push(tag);
      this.isShowTags = false;
    }
  }

  displayWith(value: any): string {
   return value ? value.sku || value.name : "";
  }

  onPaste($event: ClipboardEvent) {
    const pastedText = $event.clipboardData.getData("text");
    this.shipyardService.TypeaheadSku(this.account, pastedText, "", null, true)
      .pipe(takeUntil(this.destroy$)).subscribe((skus) => {
        this.shipmentSkuList = skus as ShipmentSku[];
      });
  }

  verifyAndLoadSku() {

    const data = {
      skuQtyList: [
        {
          sku: this.form.value.skuAutocomplete.sku
            ? this.form.value.skuAutocomplete.sku
            : this.form.value.skuAutocomplete,
        },
      ],
      account: this.account,
    };
    if (this.data.page === 'shipyard' || this.data.page === 'replenish') {
    this.shipyardService.ValidateBulkSkus(data).pipe(takeUntil(this.destroy$)).subscribe({
        next: (res: any) => {
          if (res && res.validSkus && res.validSkus.length > 0) {
            this.loadSku(res.validSkus[0]);
          } 
        },
       error: (err) => {
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 4000,
          horizontalPosition: "center",
          data: {
            title: "Invalid SKU, please try again.",
            action: "Dismiss",
            type: "error",
          },
        });
      }
    });
  }
  else if(this.data.page === 'products' && this.hasData) {
    this.selectedItems.push(this.form.value.skuAutocomplete);
    this.form.reset();
  }
 }

  loadSku(res) {
    let foundSku = [];
    if (typeof this.form.value.skuAutocomplete === "string") {
      this.shipyardService
        .TypeaheadSku(this.account, this.form.value.skuAutocomplete)
        .pipe(takeUntil(this.destroy$)).subscribe((skus: ShipmentSku[]) => {
          foundSku = skus.filter(
            (val) => val.sku === this.form.value.skuAutocomplete
          );
          this.setSKuData(foundSku, res);
        });
    } else {
      this.setSKuData(foundSku, res);
    }
  }

  setSKuData(foundSku, res) {
    if (
      foundSku.length === 1 ||
      (this.form.value.skuAutocomplete && this.form.value.skuAutocomplete.sku)
    ) {
      const sku =
        foundSku && foundSku.length
          ? foundSku[0]
          : this.form.value.skuAutocomplete;
      if (this.selectedSKU.some((b) => b.sku === sku.sku)) {
        const matchSku = this.selectedSKU.filter((b) => b.sku === sku.sku);
        matchSku[0].qty = +matchSku[0].qty + +sku.qty;
      } else {
        this.selectedSKU.push(sku as ShipmentSku);
      }
      this.form.reset();
      this.shipmentSkuList = [];
    } else {
      this.snackBar.openFromComponent(SnackbarComponent, {
        duration: 4000,
        horizontalPosition: "center",
        data: {
          title: "Invalid SKU, please try again",
          action: "Dismiss",
          type: "error",
        },
      });
    }
  }

  removeSku(sku) {
    const dialog = this.dialog.open(ConfirmDialogComponent, {
      width: "600px",
      data: {
        title: (this.data.page == 'shipyard' || this.data.page=='replenish') ? "Remove SKU" : "Remove Item",
        message: `Are you sure you want to remove ${sku.sku || sku.title} from list ?`,
      },
    });
    dialog
      .afterClosed()
      .pipe(filter((e) => e === "Confirm"))
      .subscribe((e) => {
        if (this.data.page == 'shipyard' || this.data.page=='replenish') {
          this.selectedSKU = this.selectedSKU.filter(
            (currentSku) => sku.sku !== currentSku.sku
          );
        }
        else {
          this.selectedItems = this.selectedItems.filter(
            (currentSku) => sku.name !== currentSku.name
          );
        }
      });
  }

  removeTag(tagId) {
    let idx = this.selectTags.findIndex((ele) => ele.tagId === tagId);
    if (idx !== -1) {
      this.selectTags.splice(idx, 1);
    }
  }

  validateSkus() {
    if (
      this.importBulkForm.value.skuList &&
      this.importBulkForm.value.skuList.length
    ) {
      const data = (this.parseFromCsv(this.importBulkForm.value.skuList.trim())).filter((res) => {
        return res.sku != "";
      });
      this.validate(data);
    }
  }

  parseFromCsv(file) {
    const parsedData = this.papa.parse(file, {
      delimiter: "\t",
      complete: (result: any) => { },
    });
    const returnArray = parsedData.data.map((element) => {
      return {
        sku: element[0],
        caseQty: this.data.isCaseQty ? parseInt(element[1], 10) : 0,
        qty: (this.data.isCaseQty ? (parseInt(element[2], 10)) * (parseInt(element[1], 10)) : parseInt(element[1], 10)) || 0,
      };
    });
    if (!returnArray[returnArray.length - 1].sku) returnArray.splice(-1, 1);
    return returnArray;
  }

  validate(result: any) {
    let api:any;
  this.validatorSpin = true;
  let data:any = {
    skuQtyList: result,
    account: this.account,
  };
  if(this.data.page === "shipyard" || this.data.page==='replenish'){
    api = this.shipyardService.ValidateBulkSkus(data);
  } else{
    let itemList:any[]=[];
    result.forEach((ele)=>{
      if(ele) itemList.push(ele.sku);
    })
    data={
      items: itemList
    }
    api= this.inventoryService.validateItems(data);
  }
  api.pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (res: any) => {
        this.importBulkForm.reset();
        this.validatedSku = true;
        this.validatorSpin = false;
        if(this.data.page !== "shipyard" &&  this.data.page!='replenish') {
          res.invalidSkus =res.invalidItem;
          res.validSkus=res.validateItem;
        }
        if (res && res.invalidSkus && res.invalidSkus.length) {
          this.invalidSkus = res.invalidSkus;
          this.snackBar.openFromComponent(SnackbarComponent,
            {
              duration: 4000,
              horizontalPosition: 'center',
              data: {
                title: `The following ${this.invalidSkus.length} ${(this.data.page == "shipyard" || this.data.page == "replenish") ? 'SKU' : 'Items'} were not found : 
                ${this.invalidSkus.toString()}`,
                action: 'Dismiss',
                type: 'error',
              },
            }
          );
        }
        if (res.validSkus && res.validSkus.length) {
          res.validSkus.forEach((item) => {
            item.CaseQty = item.caseQty || 0;
            if(this.data.page === "shipyard" ||  this.data.page ==='replenish'){
              this.selectedSKU.push(item as ShipmentSku);
            } else{
              this.selectedItems.push(item);
            }
          });
        }
      },
      error: (error) => {
        this.validatorSpin = false;
        this.importBulkForm.controls.skuList.setErrors({ incorrect: true });
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 5000,
            horizontalPosition: 'center',
            data: {
              title: 'Row(s) with invalid format. data must be Tab or Comma delimited',
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
      },
    });
  }
}
